export default __webpack_public_path__ + "static/media/Products_Sales&Analytics.03e7ff04.png";